import React, { PureComponent } from 'react'
import { Layout, Container, PageTitle } from 'src/components/Layout'
import { injectIntl, FormattedMessage } from 'react-intl'
import intlMessages from './translations'

class NotFound extends PureComponent {
  render() {
    const { intl } = this.props

    return (
      <Layout>
        <PageTitle title={intl.formatMessage(intlMessages.notFoundHeadline)} />
        <Container padder>
          <h2 style={{ textAlign: 'center' }}>
            <FormattedMessage
              id='app.notfound.bodyText'
              defaultMessage="We couldn't find what you're looking for"
            />
          </h2>
        </Container>
      </Layout>
    )
  }
}

export default injectIntl(NotFound)
